// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see P2PBlockListViewStartEvent
 */
export var P2PBlockListViewStart = function (_a) {
    var subjectCustomerToken = _a.subjectCustomerToken, blockingContext = _a.blockingContext;
    return ({
        name: "P2PBlockList View Start",
        parameters: {
            cdf_entity: "P2PBlockList",
            cdf_action: "View",
            subject_customer_token: subjectCustomerToken !== undefined && subjectCustomerToken !== null ? subjectCustomerToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            blocking_context: blockingContext !== undefined && blockingContext !== null ? blockingContext.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
